// 合同状态
export var contractStatus;
(function (contractStatus) {
    contractStatus["INACTIVE"] = "\u672A\u5F00\u59CB";
    contractStatus["ACTIVE"] = "\u4F7F\u7528\u4E2D";
    contractStatus["TERMINATED"] = "\u5DF2\u7ED3\u675F";
})(contractStatus || (contractStatus = {}));
// 合同还款状态
export var contractRepaymentStatus;
(function (contractRepaymentStatus) {
    contractRepaymentStatus["INACTIVE"] = "\u672A\u5F00\u59CB";
    contractRepaymentStatus["REPAYING"] = "\u8FD8\u6B3E\u4E2D";
    contractRepaymentStatus["REPAID"] = "\u5DF2\u7ED3\u675F";
    contractRepaymentStatus["OVERDUE"] = "\u5DF2\u903E\u671F";
})(contractRepaymentStatus || (contractRepaymentStatus = {}));
// 协议签署状态
export var agreementSignStatus;
(function (agreementSignStatus) {
    agreementSignStatus["UNSEND"] = "\u672A\u53D1\u9001";
    agreementSignStatus["UNSIGN"] = "\u672A\u7B7E\u7F72";
    agreementSignStatus["SIGNED"] = "\u5DF2\u7B7E\u7F72";
})(agreementSignStatus || (agreementSignStatus = {}));
// 业务模式
export var businessModel;
(function (businessModel) {
    businessModel["JINGZU"] = "\u7ECF\u79DF";
    businessModel["RONGZU"] = "\u878D\u79DF";
})(businessModel || (businessModel = {}));
// 代扣还款类型
export var amountType;
(function (amountType) {
    amountType["MONTHLY_RENT"] = "\u79DF\u91D1/\u6708\u4F9B";
    amountType["PUNISHMENT"] = "\u8FDD\u7AE0\u7F5A\u6B3E";
    amountType["DEPOSIT"] = "\u62BC\u91D1";
    amountType["MANAGEMENT"] = "\u7BA1\u7406\u8D39";
    amountType["INSURANCE"] = "\u4FDD\u9669\u8D39";
})(amountType || (amountType = {}));
// 扣款模式
export var deductMode;
(function (deductMode) {
    deductMode["DAY_AVERAGE"] = "\u65E5\u6263\u5E73\u5747";
    deductMode["DAY_GREED"] = "\u65E5\u6263\u4F18\u5148";
    deductMode["ACTIVE"] = "\u4E3B\u52A8\u8FD8\u6B3E";
})(deductMode || (deductMode = {}));
// 还款状态
export var repayStatus;
(function (repayStatus) {
    repayStatus["PAYING"] = "\u672A\u8FD8\u6E05";
    repayStatus["PAID_OFF"] = "\u5DF2\u8FD8\u6E05";
})(repayStatus || (repayStatus = {}));
